import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  ControlLabel,
  Grid,
  Button,
  Table,
  Pagination,
} from "react-bootstrap";
import Datetime from "react-datetime";
import moment from "moment";
import LoadingSpinner from "views/Components/loadingSpinner";
import NotificationSystem from "react-notification-system";
import ScreenLoader from "views/Components/screenLoader";
import Select from "react-select";
import {
  AddConsultationsData,
  getAllConsultationData,
  getAllPackageDetails,
} from "../../../api/utils/ProductUtility";

const ProductConsultation = () => {
  const _notificationSystem = React.createRef();
  const [isPDFLoading, setIsPDFLoading] = useState(false);
  const [isGRNLoading, setIsGRNLoading] = useState(false);
  const [consultationData, setConsultationData] = useState([]);
  const [consultationsStartDate, setConsultationsStartDate] = useState("");
  const [consultationsEndDate, setConsultationsEndDate] = useState("");
  const [consultationsPackageId, setConsultationsPackageId] = useState();
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [consultationResponse, setConsultationResponse] = useState();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [endDateError, setEndDateError] = useState(null);
  const [startDateError, setStartDateError] = useState(null);
  const [optionsPackage, setOptionsPackage] = useState([]);
  const [selectedOptionPackage, setSelectedOptionPackage] = useState(null);
  const [packageNameError, setPackageNameError] = useState(null);

  const GetAllPackages = async () => {
    try {
      const data = await getAllPackageDetails();
      const selectPackgeOption = data.map((pkg) => ({
        value: pkg.id,
        label: pkg.title,
      }));
      setOptionsPackage(selectPackgeOption);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  const handleChangePackage = (selected) => {
    setSelectedOptionPackage(selected);
    if (selected) {
      setPackageNameError(null);
    }
  };

  useEffect(() => {
    GetAllPackages();
    getAllConsultaionDetails();

    const interval = setInterval(() => {
      getAllConsultaionDetails();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => getAllConsultaionDetails(number)}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }

  const getAllConsultaionDetails = async (currentPage) => {
    const res = await getAllConsultationData(currentPage);
    setConsultationData(res.data || []);
    setCurrentPage(
      res && res.pagination && res.pagination.page != null
        ? res.pagination.page
        : ""
    );
    setTotalPage(
      res && res.pagination && res.pagination.total_pages != null
        ? res.pagination.total_pages
        : ""
    );
    setLoading(false);
  };

  const handleConsultationsStartDateChange = (value) => {
    const consultations_Start_date = moment(value).format("YYYY-MM-DD");
    setConsultationsStartDate(consultations_Start_date);
    if (consultations_Start_date) {
      setStartDateError(null);
    }
  };

  const handleConsultationsEndDateChange = (value) => {
    const Consultations_End_Date = moment(value).format("YYYY-MM-DD");
    setConsultationsEndDate(Consultations_End_Date);
    if (
      consultationsStartDate &&
      consultationsEndDate &&
      new Date(consultationsEndDate) <= new Date(consultationsStartDate)
    ) {
      setEndDateError(null);
    }
  };

  const handleConsultationReset = () => {
    setConsultationsEndDate("");
    setConsultationsStartDate("");
    setConsultationsPackageId("");
    setStartDateError(null);
    setEndDateError(null);
    setSelectedOptionPackage(null);
    setPackageNameError(null);
  };

  const handleConsultationsOnSubmit = async () => {
    let error = false;
    const notification = _notificationSystem.current;
    if (
      consultationsStartDate &&
      consultationsEndDate &&
      new Date(consultationsEndDate) < new Date(consultationsStartDate)
    ) {
      error = true;
      setEndDateError("Invalid date range");
      return;
    }
    if (!consultationsStartDate) {
      error = true;
      setStartDateError("Start Date is required.");
      return;
    }

    if (!consultationsEndDate) {
      error = true;
      setEndDateError("End Date is required.");
      return;
    }
    if (!selectedOptionPackage) {
      error = true;
      setPackageNameError("PackageName is required.");
      return;
    }
    if (!error) {
      try {
        const res = await AddConsultationsData(
          consultationsStartDate,
          consultationsEndDate,
          selectedOptionPackage.value
        );
        if (res && res.data) {
          setConsultationResponse(res.data);
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-check"></span>,
            message: (
              <div>
                <b>Consultation</b> - Data processing queued. Check later.
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          getAllConsultationData().then((res) => {
            setConsultationData(res.data);
            setLoading(false);
            setConsultationsEndDate("");
            setConsultationsStartDate("");
            setConsultationsPackageId();
            setSelectedOptionPackage(null);
          });
        }
      } catch (error) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>please Enter Package Name</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    }
  };

  return (
    <div className="main-content">
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <br />
        <Card
          content={
            <>
              <form>
                <div className="table-responsive">
                  <Table
                    style={{ border: "none", marginTop: "8px" }}
                    className="fl_order_details"
                  >
                    <thead>
                      <tr>
                        <th align="center">
                          <ControlLabel style={{ padding: "5px" }}>
                            Start Date
                          </ControlLabel>
                        </th>
                        <th align="center">
                          <ControlLabel style={{ padding: "5px" }}>
                            End Date
                          </ControlLabel>
                        </th>
                        <th align="center">
                          <ControlLabel style={{ padding: "5px" }}>
                            Package Name
                          </ControlLabel>
                        </th>
                        <th align="center">
                          <ControlLabel style={{ padding: "5px" }}>
                            Action
                          </ControlLabel>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              closeOnSelect={true}
                              value={consultationsStartDate || ""}
                              onChange={handleConsultationsStartDateChange}
                              inputProps={{ placeholder: "Select Start Date" }}
                            />
                            {startDateError && (
                              <small
                                className="text-danger mt-1"
                                style={{ marginLeft: "7px" }}
                              >
                                {startDateError}
                              </small>
                            )}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              closeOnSelect={true}
                              value={consultationsEndDate || ""}
                              onChange={handleConsultationsEndDateChange}
                              inputProps={{ placeholder: "Select End Date" }}
                            />
                            {endDateError && (
                              <small
                                className="text-danger mt-1"
                                style={{ marginLeft: "7px" }}
                              >
                                {endDateError}
                              </small>
                            )}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Col md={12}>
                              <Select
                                isClearable
                                isSearchable
                                options={optionsPackage}
                                value={selectedOptionPackage}
                                onChange={handleChangePackage}
                                isLoading={loading}
                                placeholder="Select a package"
                                noOptionsMessage={() => "No packages found"}
                                loadingMessage={() => "Loading packages..."}
                              />
                            </Col>
                            {packageNameError && (
                              <small
                                className="text-danger mt-1"
                                style={{ marginLeft: "16px" }}
                              >
                                {packageNameError}
                              </small>
                            )}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              flexWrap: "wrap",
                            }}
                          >
                            <Button
                              className="btn-color"
                              fill
                              onClick={handleConsultationsOnSubmit}
                            >
                              Generate
                            </Button>
                            <Button
                              className="btn-color"
                              fill
                              onClick={handleConsultationReset}
                            >
                              Clear
                            </Button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                  <Col>
                    <Card
                      content={
                        <React.Fragment>
                          <Row>
                            <Col md={12}>
                              <Table responsive className="desktop-table">
                                <thead>
                                  <tr>
                                    <th>Package Name</th>
                                    <th>created_at</th>
                                    <th>start date</th>
                                    <th>end date</th>
                                    <th>status</th>
                                    <th>Download</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loading ? (
                                    <tr>
                                      <td colSpan="10">
                                        <LoadingSpinner />
                                      </td>
                                    </tr>
                                  ) : noRecordFound ? (
                                    <tr>
                                      <td colSpan="10">
                                        <center>No record found</center>
                                      </td>
                                    </tr>
                                  ) : (
                                    consultationData &&
                                    consultationData.map((item) => (
                                      <tr>
                                        {" "}
                                        <td>{item.package_name}</td>
                                        <td>{item.created_at}</td>
                                        <td>{item.start_date}</td>
                                        <td>{item.end_date}</td>
                                        <td>{item.status}</td>
                                        <td>
                                          {item.url != null ? (
                                            <Button
                                              simple
                                              bsStyle="success"
                                              bsSize="xs"
                                              onClick={() =>
                                                window.open(item.url, "_blank")
                                              }
                                            >
                                              <i
                                                className="fa fa-download"
                                                style={{ color: "#9CF196" }}
                                              />
                                            </Button>
                                          ) : (
                                            <Button
                                              bsSize="xs"
                                              simple
                                              disabled
                                              style={{
                                                cursor: "not-allowed",
                                              }}
                                            >
                                              <i
                                                class="fa fa-ban"
                                                aria-hidden="true"
                                                style={{ color: "red" }}
                                              ></i>
                                            </Button>
                                          )}
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </Table>
                            </Col>
                          </Row>
                          {isPDFLoading && <ScreenLoader />}
                          {isGRNLoading && <ScreenLoader />}
                        </React.Fragment>
                      }
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Pagination bsSize="medium">{items}</Pagination>
                    </div>
                  </Col>
                </div>
              </form>
            </>
          }
        />
      </Grid>
    </div>
  );
};

export default ProductConsultation;
